import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import HelpText from '../../components/help/HelpText';
import { request, handleRequestErrors } from '../../helpers/Requests.js'
import { renderErrors } from '../../utilities/Forms.js'
import { debounce } from '../../utilities/Generic.js'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class AlertProcessing extends Component {
  static ANSWER_TYPES = [
    "minus_two",
    "minus_one",
    "zero",
    "one",
    "two",
    "text"
  ];

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.initializeData = this.initializeData.bind(this);
    this.handlePartialChange = this.handlePartialChange.bind(this);
    this.debouncedHandlePersonSearch = debounce(this.handlePersonSearch.bind(this), 500);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
  }

  state = {
    tabIndex: 0,
    users: [],
    partial: "",

    alertsLoaded: false,
    locationsLoaded: false,
    usersLoaded: false,

    updated: "",
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    const [bucket, answer_type, attribute] = name.split('|');

    this.setState(prevState => {
      let state = JSON.parse(JSON.stringify(prevState)) // deep copy
      state[bucket][answer_type][attribute] = value
      return state
    })
  }

  handleMultiCheckbox(event, targetKey) {
    const name = parseInt(event.target.name);
    const value = event.target.checked;

    const [bucket, answer_type, attribute] = targetKey.split('|');
    let array = this.state[bucket][answer_type][attribute]

    if (value === true) {
      if (!array.includes(name)) {
        array.push(name)
      }
    }
    else if (value === false) {
      if (array.includes(name)) {
        let index = array.indexOf(name)
        array.splice(index, 1)
      }
    }

    this.setState(prevState => {
      let state = JSON.parse(JSON.stringify(prevState)) // deep copy
      state[bucket][answer_type][attribute] = array
      return state
    })
  }

  handleTabChange(index) {
    this.setState({ tabIndex: index });
  }

  handlePartialChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    this.debouncedHandlePersonSearch(value)
  }

  handlePersonSearch(partial) {
    if (partial === "") {
      // Re-sort all users because the selection may have changed in the partial view
      return this.setState(prevState => {
        let state = JSON.parse(JSON.stringify(prevState)) // deep copy
        state.locations.forEach(location => {
          const bucket = `location_${location.id}`

          state[bucket]["searchedUsers"] = null
          state[bucket]["users"] = this.sortUsersByAssociation(state.users, location.id) 
        })

        state["all_locations"]["searchedUsers"] = null
        state["all_locations"]["users"] = this.sortUsersByAssociation(state.users, null) 

        return state
      })
    }

    request('GET', `/v1/a/users/names_and_ids?user[search]=${partial}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState(prevState => {
          let state = JSON.parse(JSON.stringify(prevState)) // deep copy
          state.locations.forEach(location => {
            const bucket = `location_${location.id}`
            state[bucket]["searchedUsers"] = this.sortUsersByAssociation(data, location.id)
          })
          state["all_locations"]["searchedUsers"] = this.sortUsersByAssociation(data, null)
          state.usersLoaded = true

          return state
        })
      })
      .catch(error => handleRequestErrors(this, error))
  }

  handleCheckbox(event) {
    let name = event.target.name;
    let value = event.target.checked;

    const [bucket, answer_type, attribute] = name.split('|');

    this.setState(prevState => {
      let state = JSON.parse(JSON.stringify(prevState)) // deep copy

      state[bucket][answer_type][attribute] = value
      return state
    })
  }

  handleSubmit() {
    if (this.state.alertsLoaded === false) {
      const verb = this.props.origin === "create" ? "created" : "updated"
      sessionStorage.setItem("updateSuccess", `Feedback Question ${verb} successfully! (Alerts were skipped)`);
      this.props.closePanel()
      return
    }

    let id = this.props.id;

    let json = {
      "feedback_question": {
        "feedback_answer_alerts_attributes": []
      }
    }

    json = this.compileJSON(null, json);

    this.state.locations.map((location) => (
      json = this.compileJSON(location.id, json)
    ))

    json = JSON.stringify(json)

    request("POST", `/v1/a/feedback_questions/${id}/set_feedback_alerts`, json, () => {this.setState({ unauthorized: true })})
    .then(data => {
      this.setState({ updated: true, errors: "" })

      const verb = this.props.origin === "create" ? "created" : "updated"
      sessionStorage.setItem("updateSuccess", `Feedback Question ${verb} successfully!`);
      this.props.closePanel()
    })
    .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }

  compileJSON(location_id, json) {
    let alerts

    if (location_id === null) {
      alerts = this.state.all_locations
    }
    else {
      alerts = this.state[`location_${location_id}`]
    }

    AlertProcessing.ANSWER_TYPES.forEach((answer_type) => {
      const alert = alerts[answer_type]

      // "_destroy" marks a record for deletion by evaluating to true if an ID is present but user_ids not present and the alert email and action needed flag are disabled.
      const _destroy = (
        alert.user_ids.length === 0
        && alert.action_needed === false
      )

      let answer_json = {
        "answer_value": answer_type,
        "id": alert.id,
        "user_ids": alert.user_ids,
        "enabled": alert.enabled,
        "action_needed": alert.action_needed,
        "location_id": location_id,
        "_destroy": _destroy
      }

      if (answer_type === "text") {
        answer_json["text_contains"] = alert.text_contains
      }

      let userData = true

      if (alert.user_ids.length === 0) {
        userData = false
      }

      // include data about this answer value in the json payload only if this answer value's alert contains data
      if (
        userData
        || alert.id
        || alert.action_needed
      ) {
        json.feedback_question.feedback_answer_alerts_attributes.push(answer_json)
      }
    })

    return json
  }

  renderAlertFields(current_answer_type, location_id) {
    const minimum_answers = ["4", "2"].includes(this.props.current_answer_quantity);
    const titles = {
      boolean: {
        minus_two: "No",
        zero: "N/A",
        two: "Yes"
      },
      stars: {
        minus_two: "One Star",
        minus_one: "Two Stars",
        zero: "Three Stars",
        one: !minimum_answers ? "Four Stars" : "Three Stars",
        two: !minimum_answers ? "Five Stars" : "Four Stars"
      },
      smileys: {
        minus_two: "Very Unhappy",
        minus_one: "Unhappy",
        zero: "Neutral",
        one: "Happy",
        two: "Very Happy"
      },
      thumbs: {
        minus_two: "Two Thumbs Down",
        minus_one: "One Thumb Down",
        zero: "No Thumbs Up",
        one: "One Thumb Up",
        two: "Two Thumbs Up"
      },
      net_promoter: {
        minus_two: "Negative",
        zero: "Neutral",
        two: "Positive",
      },
      text:{
        text: "Follow up for Text Answer"
      }
    };

    let bucket  = location_id === null ? "all_locations" : "location_" + location_id;
    let user_ids_keys = [];
    let labels = [];

    Object.entries(titles[current_answer_type]).forEach(([key, value]) => {
      if (minimum_answers && key === "zero") {
        return;
      }
      
      user_ids_keys.push(`${bucket}|${key}|user_ids`);
      labels.push(value);
    });

    labels = current_answer_type === "text" ? ["Send Emails?"] : labels
      
    return (
      <div className="row top-padding">
        <HelpText page={'alertProcessing'} section={'action_needed'} />
        Require follow up actions for:
        {this.renderActionNeededRow(titles, current_answer_type, location_id, minimum_answers)}
        {current_answer_type === "text" && (
          <>
            <label className="column alert-title">Text Contains:</label>
            <HelpText className="inline" page={'alertProcessing'} section={'textContains'} />
            <textarea className="column" name={`${bucket}|text|text_contains`} value={alert.text_contains} onChange={this.handleChange} />
          </>
        )}
        <HelpText page={'alertProcessing'} section={'user_selection'} />
        <label className="column">Users emailed Alerts:</label>{ renderErrors(this.state.errors, 'arrival_email_user') }{ renderErrors(this.state.errors, 'departure_email_user') }
        <input name="partial" placeholder="Enter text to search" className="search-text" onChange={this.handlePartialChange} value={this.state.partial} />
        {this.renderUsersSelection((this.state[bucket]["searchedUsers"] || this.state[bucket]["users"]), user_ids_keys, labels)}
      </div>
    )
  }

  filterUsers(users, location_id) {
    if (location_id === null) {
      return users
    }

    return users.filter(user => user.location_ids.includes(location_id))
  }

  renderActionNeededRow(titles, question_type, location_id, minimum_answers = false) {
    const currentTypeTitles = titles[question_type];

    const activeEntries = Object.entries(currentTypeTitles).filter(([answer_type]) => {
      if (minimum_answers && answer_type === "zero") {
        return false;
      }
      return true;
    });

    let bucket = location_id === null ? "all_locations" : "location_" + location_id;

    return (
      <div>
        <table className="checkbox-table">
          <thead>
            <tr>
              {activeEntries.map(([answer_type, title]) => {
                const key = `${bucket}|${answer_type}|action_needed`

                return (
                  <th key={key}>
                    <label className="checkbox-label" htmlFor={key}>
                      {title}
                    </label>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              {activeEntries.map(([answer_type]) => {
                let alert = this.state[bucket]?.[answer_type]
                const key = `${bucket}|${answer_type}|action_needed`

                return (
                  <td key={key} className="center">
                    <input className="column" type="checkbox" name={key} id={key} checked={alert.action_needed} onChange={this.handleCheckbox} 
                    />
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderUsersSelection(assignable_users, keys, labels) {
    return (
      <div className="scrollable-table">
        <table className="checkbox-table">
          <thead>
            <tr>
              <th>Name</th>
              {labels.map((label, index) => {
                const [bucket, answer_type] = keys[index].split('|');
                let alert = this.state[bucket]?.[answer_type]

                return (
                  <th key={label} className="table-header-cell">
                    <div className="header-flex-container">
                      <span className="header-label">{label}</span>
                      <input className="column" type="checkbox" name={`${bucket}|${answer_type}|enabled`} id={`${bucket}|${answer_type}|enabled`} checked={alert.enabled} onChange={this.handleCheckbox} />
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {assignable_users.map(user => (
              <tr key={user.id}>
                <td>
                  <Link to={`/settings/users/${user.id}`}>{user.first_name} {user.last_name}</Link>
                </td>
                {keys.map(key => {
                  const [bucket, answer_type, attribute] = key.split('|');
                  const user_ids = this.state[bucket][answer_type][attribute]
                  let alert = this.state[bucket]?.[answer_type]

                  return (
                    <td className="center-cell" key={key}>
                      <input className="column" type="checkbox" data-name={user.email} name={user.id} data-key={key} disabled={alert.enabled === false} checked={user_ids.includes(user.id)} onChange={event => this.handleMultiCheckbox(event, key)} />
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    const { locations, tabIndex, alertsLoaded, locationsLoaded, unauthorized, error, errors, usersLoaded } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (alertsLoaded === false || locationsLoaded === false || usersLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (!this.props.current_answer_type) {
      return <p className="bottom-padding center segment">Choose an answer type in order to set up alerts.</p>
    }

    let current_answer_type = this.props.current_answer_type

    if (current_answer_type === "multi_select") {
      return <div className="settings big-settings strong">Multi-Select answers do not currently support Feedback Alerts.</div>
    }

    if (alertsLoaded && locationsLoaded) {
      return (
        <div>
          <form className="settings big-settings">
            { renderErrors(errors, 'feedback_answer_alerts.id') }
            { renderErrors(errors, 'feedback_answer_alerts.enabled') }
            { renderErrors(errors, 'feedback_answer_alerts.answer_value') }

            <div>
              <HelpText page={'alertProcessing'} section={current_answer_type} />
              <h3 className="alert-processing title">Alert Processing</h3>

              <Tabs selectedIndex={tabIndex} onSelect={index => this.handleTabChange(index)}>
                <div className="tab-container">
                  <TabList>
                    <Tab key={0}>All Locations</Tab>
                    {locations.map((location) => (
                      <Tab key={location.id}>{location.name}</Tab>
                    ))}
                  </TabList>
                </div>

                <TabPanel key={"all_locations"}>
                  { this.renderAlertFields(current_answer_type, null) }
                </TabPanel>

                {locations.map((location) => (
                  <TabPanel key={location.id}>
                    { this.renderAlertFields(current_answer_type, location.id) }
                  </TabPanel>
                ))}
              </Tabs>
            </div>
          </form>
        </div>
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.submitAlertsCount !== this.props.submitAlertsCount) {
      this.handleSubmit()
    }
  }

  fillLocations(collection, locations) {
    locations.map((location) => (
      collection[`location_${location.id}`] = {}
    ))

    return collection
  }

  fillDefaultData(collection) {
    for (var key in collection) {
      collection[key]["users"] = []
      collection[key]["searchedUsers"] = null

      for (const alert_type of AlertProcessing.ANSWER_TYPES) {
        collection[key][alert_type] = {
          id: null,
          user_ids: [],
          saved_user_ids: [],
          enabled: true,
          action_needed: false,
          text_contains: ""
        }
      }
    }

    return collection
  }

  setUpData(data, locations) {
    let collection = {
      all_locations: {}
    }

    collection = this.fillLocations(collection, locations)
    collection = this.fillDefaultData(collection)

    data.map((alert) => (
      collection = this.processApiData(alert, collection)
    ))

    return collection
  }

  processApiData(data, collection) {
    if (data.location_id !== null && collection[`location_${data.location_id}`] === undefined) {
      return collection
    }

    let alert = data.location_id === null ? collection["all_locations"][data.answer_value] : collection[`location_${data.location_id}`][data.answer_value]

    alert.id = data.id
    alert.user_ids = data.user_ids
    alert.enabled = data.enabled
    alert.action_needed = data.action_needed
    alert.text_contains = data.text_contains

    return collection
  }

  initializeData(alerts, locations = this.state.locations) {
    let stateValues = {}

    const collection = this.setUpData(alerts, locations)

    for (var key in collection) {
      stateValues[key] = collection[key]
    }

    stateValues["alertsLoaded"] = true

    this.setState(stateValues)
  }

  sortUsersByAssociation(users, location_id) {
    const filteredUsers = this.filterUsers(users, location_id)

    const location = location_id === null ? "all_locations" : `location_${location_id}`

    const keys  = [];
    for (const alert_type of AlertProcessing.ANSWER_TYPES) {
      keys.push(this.state[location][alert_type]["user_ids"])
    }

    const sortedUsers = [...filteredUsers].sort((a, b) => {
      // A user is considered selected if they're selected for any of the columns
      const aSelected = keys.some(key => key.includes(a.id));
      const bSelected = keys.some(key => key.includes(b.id));

      return bSelected - aSelected; // selected users first
    });

    return sortedUsers
  }


  fetchUsers() {     
    request('GET', `/v1/a/users/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState(prevState => {
          let state = JSON.parse(JSON.stringify(prevState)) // deep copy
          state.locations.forEach(location => {
            const bucket = `location_${location.id}`
            state[bucket]["users"] = this.sortUsersByAssociation(data, location.id)
          })
          state["all_locations"]["users"] = this.sortUsersByAssociation(data, null)
          state.users = data
          state.usersLoaded = true

          return state
        })
      })
      .catch(error => handleRequestErrors(this, error, { usersLoaded: true }))
  }

  componentDidMount() {
    let id = this.props.id;

    request("GET", `/v1/a/locations/names_and_ids`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        this.setState({ locations: data, locationsLoaded: true })

        if (id === null || id === undefined) {
          this.initializeData([], data)
          this.fetchUsers()
          return
        }

        request("GET", `/v1/a/feedback_questions/${id}/feedback_alerts`, "", () => {this.setState({unauthorized: true})})
          .then(data => {
            this.initializeData(data)
            this.fetchUsers()
          })
          .catch(error => handleRequestErrors(this, error, { alertsLoaded: true }))
      })
      .catch(error => handleRequestErrors(this, error, { locationsLoaded: true }))
  }
}

export default AlertProcessing;
